// useOnlineStatus — отслеживает реальную сетевую доступность.
// Источник правды — `lib/network-status` (тот же, что у TanStack onlineManager).
// См. rules/offline-sync.md §2.5b.
import { useEffect, useState } from "react";
import { subscribeOnlineStatus } from "@/lib/network-status";

export function useOnlineStatus(): boolean {
	const [isOnline, setIsOnline] = useState<boolean>(() =>
		typeof navigator === "undefined" ? true : navigator.onLine,
	);

	useEffect(() => subscribeOnlineStatus(setIsOnline), []);

	return isOnline;
}
